import api from "./client";
const routeApi = {
    getDistricts() {
        return api.get("/rota/districts").then((res) => res.data);
    },
    runClustering(params) {
        return api.post("/rota/clustering/run", params).then((res) => res.data);
    },
    optimizeRoute(params) {
        return api.post("/rota/optimize", params).then((res) => res.data);
    },
    generateCorridor(params) {
        return api.get("/rota/corridor/generate", { params }).then((res) => res.data);
    },
    getClusteringResults() {
        return api.get("/rota/clustering/results").then((res) => res.data);
    },
    getClusteringCache() {
        return api.get("/rota/clustering/cache").then((res) => res.data);
    },
    /**
     * @deprecated Backend GET /api/rota/results/:id yok. Chat paketi kullanmaz.
     * Çağıran yok; 404 yutulmaz. RouteOpt ajanı bu uca bağlanmaz.
     */
    getRouteResults(optimizationId) {
        return api.get(`/rota/results/${optimizationId}`).then((res) => res.data);
    },
};
export default routeApi;
